import { Datagrid, FunctionField, List, Pagination } from "react-admin";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { RaRowActions } from "../../components/RaRowActions";
import { AppBulkDeleteButton } from "../../components/AppBulkDeleteButton";
import { CategoryDot } from "../../components/CategoryChip";
import { colors, radius, shadows } from "../../data/tokens";

// Tela simples (8 categorias fixas): sem busca/exportação — o "Novo"
// do breadcrumb cobre a criação.
export const UserCategoryList = () => {
  return (
    <>
      <PageTopBreadcrumb
        title="Categoria de Sócios"
        firstPath="/#/user-categories/crud"
        actionType="create"
      />
      <List
        actions={false}
        perPage={20}
        pagination={<Pagination rowsPerPageOptions={[10, 20, 50]} />}
        queryOptions={{ keepPreviousData: true }}
        sx={{
          "& .RaList-main": {
            backgroundColor: colors.white,
            borderRadius: `${radius.lg}px`,
            boxShadow: shadows.card,
            padding: "12px 20px 8px",
          },
          "& .RaList-content": {
            boxShadow: "none",
            backgroundColor: "transparent",
          },
        }}
      >
        <Datagrid
          rowClick="show"
          bulkActionButtons={<AppBulkDeleteButton />}
          sx={{
            "& .RaDatagrid-headerCell": {
              fontSize: 11.5,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              color: colors.textMuted,
              backgroundColor: colors.bgSubtle,
              paddingTop: 1,
              paddingBottom: 1,
            },
            "& .RaDatagrid-rowCell": { paddingTop: 0.75, paddingBottom: 0.75 },
          }}
        >
          <FunctionField
            label="Categoria"
            sortBy="name"
            render={(record: any) => <CategoryDot name={record.name} />}
          />
          <FunctionField
            label="Ações"
            textAlign="right"
            render={() => <RaRowActions />}
          />
        </Datagrid>
      </List>
    </>
  );
};
